// extracted by mini-css-extract-plugin
module.exports = {"body":"DesignSystem_body__233hI"};